<div [class]="'unity-button-segmented ' + classes" role="group" data-toggle="button" [class.disabled]="disabled">
  <ng-content></ng-content>
</div>
